module.exports = __webpack_public_path__ + "img/icon_personal_msg2.a1d7c22c.svg";